var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.getYieldByYearList)?_c('div',{staticClass:"yield-boxplot-chart"},[(_vm.getYieldByYearList)?_c('yield-box-plot',{attrs:{"title":_vm.$t('charts.yield-by-year.title'),"yield-by-year-list":_vm.getYieldByYearList}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }